var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.elementClass},[_c('div',{staticClass:"--overlay",on:{"click":_vm.click}}),_c('div',{staticClass:"--element"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }